// src/layouts/MainLayout.jsx
import React from "react";
import Topbar from "../Topbar/Topbar";
import Sidebar from "../Sidebar/Sidebar";
import PoweredBy from "./powered-by";

const MainLayout = ({ selectedTab, children }) => {
  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        backgroundColor: "#F3F6F9",
        overflow: "hidden",
      }}
    >
      {/* Sidebar */}
      <div
        className="d-none d-lg-block"
        style={{
          height: "100vh",
          zIndex: 1000,
          flexShrink: 0,
          background: "#fff",
        }}
      >
        <Sidebar selectedTab={selectedTab} />
      </div>

      {/* Right side */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        {/* Topbar */}
        <Topbar selectedTab={selectedTab} />
        {/* Page Content */}
        <div style={{ flex: 1, overflowY: "auto", position: "relative" }}>
          {children} 
          <PoweredBy />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
